// React Hook Form doesn't support flat arrays in useFieldArray,
// because under the hood, it adds an id field to each element in the array to be used as React keys.
// So, this is a workaround, which converts an array of strings into an array of objects, with the string under a "value" field
export const unflattenFieldArray = (fieldArr) => {
  return (
    fieldArr?.map((str) => {
      return { value: str };
    }) ?? []
  );
};

// When writing form data back to db,
// we can flatten the objects used in RHF back into array of strings.
export const flattenFieldArray = (fieldObjArr) => {
  return fieldObjArr.map((obj) => obj.value);
};
